<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JFIR12/tc-custom/9798891550643.jpg?1726273345287" alt="This image is the cover for the book Irrevocable Acts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Irrevocable Acts
      </h1>
      <p class="bookDescription body article font2">
        <p>After spending a day at the Oregon zoo with 5-year old Gracie, Anna Sanders reaches a decision: she will risk anything and everything to give her daughter and her granddaughter the chance of a livable future.</p><p>But first she has to come to terms with her past. She reaches out to two childhood friends who she was in college with: Mac, a hard-drinking, pot-smoking professor of physics and climatology in Wisconsin, and Danny, an introverted college dropout working as a landscaper in Arizona. She asks to set up a meeting with them, and while both men fear such a reunion will wake the sleeping dragons of their collective history, old loyalties, and old fears, propel them forward.</p><p>In a desert house in Four Corners, New Mexico, the three come together for the first time in nineteen years. There, they reconnect, open old wounds and reveal deep secrets that shaped their pasts and will transform their futures in ways none of them could have imagined.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jonnie Hyde
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>Jonnie Hyde is a PhD psychologist living in SW Washington, where she founded and was executive director of a large community mental health center. After retiring in 2017, she decided to pursue her lifelong goal of writing a novel. And since she has been a close follower of climate science and climate change since reading Paul Ehrlic&rsquo;s <em>The Population Bomb</em> in 1970, she decided to bring these two passions together in her novel, <em>Irrevocable Acts.</em></span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4230fa7e